'use client';

import { ReactNode } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import Link from 'next/link';

export const HomeOptions = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="p-5 w-44">
          <div className="text-sm font-bold mb-1.5 text-[#42576CCC]">
            General
          </div>
          <DropdownMenuItem className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer">
            <Link
              href="/about"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              About
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer">
            <Link
              href="https://sites.google.com/player3.io/partnerprogram?usp=sharing"
              target="_blank"
              className="w-full"
              rel="noopener noreferrer"
            >
              Partners
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer"
          >
            <Link
              href="/merch"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              Merch Store
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer"
            disabled
          >
            <Link
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              Blog
            </Link>
          </DropdownMenuItem>
          <div className="text-sm font-bold my-1.5 text-[#42576CCC]">
            Support & Legal
          </div>
          <DropdownMenuItem className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer">
            <Link
              href="mailto:help@player3.io"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              Help
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer">
            <Link
              href="/terms-and-conditions/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              Terms
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem className="flex items-center px-1 py-2 text-xs font-medium hover:cursor-pointer">
            <Link
              href="/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              Privacy
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
